import React, { useEffect, useRef } from 'react';
import { getDevice, momentFormaterISO } from '@panel/commons/helpers';
import ReactDatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import './configLocales';
import { InputText } from './InputText';
import StyledDatapicker from './styles';

const CustomInput = React.forwardRef(
  ({ value, onClick, onChange, placeHolder = 'dd/mm/aaaa', label, currentDate, active }, ref) => {
    const device = getDevice();
    const inputRef = useRef(ref);

    useEffect(() => {
      if (inputRef.current) {
        inputRef.current.value = value;
      }
    }, [value]);

    return (
      <button
        type='button'
        onClick={onClick}
        ref={ref}
        style={{ height: '50px', width: device === 'mobile' ? '145px' : '174px' }}
        id={`input-${label}`}
      >
        <InputText
          iconName='calendar'
          placeHolder={placeHolder}
          width={device === 'mobile' ? '145px' : '174px'}
          label={label}
          value={currentDate ? momentFormaterISO(currentDate, 'DD/MM/YYYY') : ''}
          ref={inputRef}
          onChange={onChange}
          onClick={onClick}
          active={active}
          invalidDate={false}
        />
      </button>
    );
  }
);

const DatePickerCustom = ({
  maxDate,
  minDate,
  startDate,
  endDate,
  onChangeFrom,
  onChangeTo,
  locale = '',
  customHeader = () => {},
  handleCalendarOpenFrom = () => {},
  handleCalendarCloseFrom = () => {},
  handleCalendarOpenTo = () => {},
  handleCalendarCloseTo = () => {},
  activeStart,
  activeEnd,
  isStatisticsByPosting
}) => {
  const getFlipBehavior = () => {
    if (isStatisticsByPosting) return ['bottom'];
    return ['bottom', 'top'];
  };

  return (
    <>
      <StyledDatapicker disabledColor={startDate}>
        <ReactDatePicker
          locale={locale}
          dateFormat='dd/MM/yyyy'
          calendarClassName='CustomCalendar'
          dayClassName={() => 'customdayClassName'}
          customInput={React.createElement(
            'div',
            {},
            <CustomInput label='from' currentDate={startDate} active={activeStart} />
          )}
          renderCustomHeader={customHeader}
          selected={startDate}
          selectsStart
          startDate={startDate}
          endDate={endDate}
          onChange={onChangeFrom}
          maxDate={endDate || maxDate}
          minDate={minDate}
          onCalendarOpen={handleCalendarOpenFrom}
          onCalendarClose={handleCalendarCloseFrom}
          showPopperArrow={false}
          popperPlacement='bottom-start'
          popperModifiers={{
            flip: { behavior: getFlipBehavior() }
          }}
        />
      </StyledDatapicker>
      <StyledDatapicker disabledColor={endDate}>
        <ReactDatePicker
          locale={locale}
          dateFormat='dd/MM/yyyy'
          calendarClassName='CustomCalendar'
          dayClassName={() => 'customdayClassName'}
          customInput={React.createElement(
            'div',
            {},
            <CustomInput label='to' currentDate={endDate} active={activeEnd} />
          )}
          renderCustomHeader={customHeader}
          selected={endDate}
          selectsEnd
          startDate={startDate}
          endDate={endDate}
          onChange={onChangeTo}
          maxDate={maxDate}
          minDate={startDate || minDate}
          onCalendarOpen={handleCalendarOpenTo}
          onCalendarClose={handleCalendarCloseTo}
          showPopperArrow={false}
          popperPlacement='bottom-end'
          popperModifiers={{
            flip: { behavior: getFlipBehavior() }
          }}
        />
      </StyledDatapicker>
    </>
  );
};

export default DatePickerCustom;
